/**
 * Quanto o índice "Artefatos desta conversa" pode ter de largura sem cobrir o
 * trilho (§5.1 do CLAUDE.md do módulo).
 *
 * O cartão é absoluto no canto superior direito do container que rola, e o
 * trilho é uma coluna CENTRALIZADA nele (`.ia-chat-trilho`, `margin: auto`).
 * Sobra `(container − trilho) / 2` de cada lado; o cartão só pode ocupar
 * essa faixa, menos um respiro contra a borda do container (o `right: 16px`
 * que ele já tem) e outro contra a borda do trilho. Com a lateral da
 * imersiva aberta numa janela de 1920px sobravam 168px por lado — o cartão
 * de 180px invadia a bolha do usuário (print de 14/09/2026).
 *
 * Pura: recebe medidas, devolve pixels. Quem mede é o `messages.vue`.
 */
export const RESPIRO_DO_INDICE_DE_ARTEFATOS = 16

export function larguraMaximaDoIndiceDeArtefatos({ larguraDoContainer, larguraDoTrilho }) {
  const container = Number(larguraDoContainer) || 0
  const trilho = Number(larguraDoTrilho) || 0
  const faixaLivre = (container - trilho) / 2
  return Math.max(0, Math.floor(faixaLivre - 2 * RESPIRO_DO_INDICE_DE_ARTEFATOS))
}
